import mutations from './mutations'
import actions from './action'
import getters from './getters'

export default {
  namespaced: true,
  state: {
    role: '2',
    path: '/project/joined/list',
    activeTab: null,
    status: null,
    name: '',
    prjType: '1',
    root: null,
    prjCategory: 0
  },
  getters,
  actions,
  mutations,
  modules: {}
}
